import idb from "@/plugins/indexdb.js";
import PatientsRepository from "../../repositories/patientsRepository";

function initialPatientState() {
  return {
    uuid: "",
    lastname: "",
    firstname: "",
    email: "",
    patient_id: "",
    nir: "",
    nir_key: "",
    dob: "",
    address: "",
    zipcode: "",
    city: "",
    phone: "",
    cellular: ""
  };
}

export default {
  namespaced: true,
  state: {
    patients: [],
    patient: initialPatientState()
  },
  mutations: {
    // Set patients
    setPatients(state, patients) {
      state.patients = patients;
    }
  },
  actions: {
    // Get all patients from api
    async getPatients({ commit, state }) {
      try {
        const { data } = await PatientsRepository.get();
        commit("setPatients", data);

        await idb.db.patients.bulkPut(state.patients);
      } catch (error) {
        console.log(error);
      }
    },

    // Get a patient from api
    async getPatient(context, patientUuid) {
      const { data } = await PatientsRepository.getPatient(patientUuid);
      return data;
    },

    // Get all local patients from IndexedDB
    async getLocalPatients() {
      try {
        const patients = await idb.db.patients.toArray();
        return patients;
      } catch (error) {
        console.log(error);
      }
    },

    // Get local patient from IndexedDB
    getLocalPatient(context, patientUuid) {
      return new Promise((resolve, reject) => {
        idb.db.patients
          .get(patientUuid)
          .then(res => {
            if (!res) {
              reject("Patient not found. UUID: " + patientUuid);
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // Store a patient in API
    async createPatient(context, payload) {
      const { data } = await PatientsRepository.createPatient(payload);
      return data;
    },

    // Store a patient in local DB
    createLocalPatient(context, payload) {
      return new Promise((resolve, reject) => {
        idb.db.patients
          .add(payload)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // Clean store
    async clean({ commit }) {
      commit("setPatients", []);
      return;
    }
  },
  getters: {
    // Get a ptient by uuid
    getByUuid: state => uuid => {
      return state.patients.find(patient => patient.uuid == uuid);
    }
  }
};
